import { useFilteredSearch } from '@hooks/useFilteredSearch';
import { getDocumentsByStudio } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio';
import { GetDocumentsByStudioFilter } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';
import { selectStudio } from '@store/redux/features/auth/authSelector';
import { selectTiming } from '@store/redux/features/filter/filterSelectors';
import { updateDocumentsUpdatedAt } from '@store/redux/features/filter/filterSlice';
import { useEffect } from 'react';
import { useInfiniteQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { DocumentsBody } from './components/DocumentsBody/DocumentsBody.query';
import { Heading } from './components/Heading/Heading';
import { StyledDiv } from './Documents.styles';
import { makeGetDocumentsByStudioParams } from './Documents.utils';

export function Documents() {
  const { documentsUpdatedAt } = useSelector(selectTiming());
  const studioId = useSelector(selectStudio());
  const dispatch = useDispatch();

  const documentsFilter = useFilteredSearch<GetDocumentsByStudioFilter>({
    updatedAt: documentsUpdatedAt,
  });
  const { pageFilter } = documentsFilter;
  const documentsQuery = useInfiniteQuery({
    queryFn: ({ pageParam = 1 }) => {
      return getDocumentsByStudio(
        makeGetDocumentsByStudioParams(studioId, pageParam, pageFilter),
      );
    },
    queryKey: ['documents', 'page', pageFilter],
    getNextPageParam: lastPage =>
      lastPage.hasMore ? lastPage.currentPage + 1 : undefined,
  });

  useEffect(() => {
    dispatch(updateDocumentsUpdatedAt(pageFilter.updatedAt));
  }, [pageFilter.updatedAt]);

  return (
    <StyledDiv className="reset-global">
      <Heading {...documentsFilter} />
      <DocumentsBody {...documentsFilter} query={documentsQuery} />
    </StyledDiv>
  );
}
